import React, { FC } from 'react';
import { CSS } from '@dnd-kit/utilities';
import { makeStyles } from '@material-ui/core/styles';
import { StageItemProps } from 'components/Stage/StageItem';
import { Tab } from '@material-ui/core';
import { useSortable } from '@dnd-kit/sortable';

export interface DraggableStageItemProps extends StageItemProps {
    entityKey: string;
}

const useStyles = makeStyles(theme => ({
    root: {
        minWidth: 110,
        maxWidth: 110,
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        opacity: 0.5,
        [theme.breakpoints.up(640)]: {
            minWidth: 130,
            maxWidth: 130,
        },
        [theme.breakpoints.up(768)]: {
            minWidth: 150,
            maxWidth: 150,
        },
        [theme.breakpoints.up(1280)]: {
            minWidth: 180,
            maxWidth: 180,
        },
        '& span': {
            alignItems: 'normal',
        },
    },
    selected: {
        opacity: 1,
    },
}));

export const DraggableStageItem: FC<DraggableStageItemProps> = props => {
    const { entityKey, ...rest } = props;
    const classes = useStyles();

    const { attributes, listeners, setNodeRef: categoryDragRef, transform, transition, isDragging } = useSortable({
        id: entityKey,
    });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0 : props.selected ? 1 : 0.5,
    };

    return <Tab classes={classes} style={style} innerRef={categoryDragRef} {...listeners} {...attributes} {...rest} />;
};
